<template lang="pug">
  #CustomerTagModel.CustomerModel.CustomerModel-tagModel.px-3.pt-3(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .row.align-items-start.mb-2
      .col-10
        h2.mb-0 {{ title }}
      .col-2
        img.rounded-circle.closeIcon(
          v-lazy="iconUrl.IconClose",
          fluid,
          alt="Close Icon",
          @click="closeModel()"
        )
    .content
      multiselect.multiselect__dark(
        v-model="userLabels",
        tag-placeholder="新增標籤",
        placeholder="輸入文字新增標籤",
        selectLabel="點擊新增標籤",
        deselectLabel="點擊移除標籤",
        selectedLabel="已選擇",
        label="tag_name",
        track-by="tag_key",
        group-values="tag",
        group-label="group",
        :options="tagsOption",
        :multiple="true",
        :taggable="true",
        @tag="addLabelHandler",
        noOptions="無標籤"
      )
        template(slot="Label", slot-scope='{ tags }')
        template(slot="noOptions")
          strong 請按 Enter 新增顧客標籤
      small.d-block.w-100.mt-1.text-muted 直接在上方欄位輸入新標籤後點選新增標籤即可新增標籤
      p.mt-3(style='font-size: 1rem;') 顧問標籤
      .tagContainer.w-100.d-flex.my-3
        button.btn.button_custom-primary.mr-2.mb-2.position-relative(style="min-width: 2.5rem;" v-for="(tag, index) in baLabels") {{ tag.tag_name }}
      p 公司標籤
      .tagContainer.w-100.d-flex.my-3
        button.btn.button_custom-primary.mr-2.mb-2.position-relative(style="min-width: 2.5rem;" v-for="(tag, index) in backendLabels") {{ tag.tag_name }}

    .position-sticky(style='height: 4rem; background-color: #FFF; bottom: 0;')
      button.button.btn-block.button_clickCustom.button_clickCustom-primary.button_fixedAtBottom.position-absolute.bottom-left.mb-2(@click="close") 關閉
      button.button.btn-block.button_clickCustom.button_clickCustom-primary.button_fixedAtBottom.position-absolute.bottom-right.mt-0.mb-2(@click="save")  儲存
</template>

<script>
import { mapState } from 'vuex';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';

const _ = require('lodash');

export default {
  name: 'TagModel',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      user: null,
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      time: +new Date(),
      userLabels: [],
      tagsOption: []
    };
  },
  mounted() {
    this.$EventBus.$on('openTagModel', (user) => {
      this.initHandler(user);
    });
  },
  methods: {
    initHandler(user) {
      const vm = this;
      vm.tagsOption = _.cloneDeep(vm.tags);
      vm.userLabels = _.cloneDeep(vm.memberTags);
      vm.$set(vm, 'user', user);
      vm.openModel();
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      const vm = this;
      if (!_.isEqual(_.sortBy(vm.userLabels), _.sortBy(vm.memberTags))) {
        vm.$swal.fire({
          title: '',
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          confirmButtonText: '儲存離開',
          cancelButtonText: '繼續編輯',
          reverseButtons: false,
          showDenyButton: true,
          denyButtonText: '不儲存離開',
          customClass: {
            confirmButton: 'btn btn-primary px-5 d-block btn-block',
            cancelButton: 'btn btn-gray px-5 d-block btn-block',
            denyButton: 'btn btn-danger px-5 d-block btn-block'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            vm.save();
          } else if (result.isDenied) {
            vm.close();
          }
        });
      } else {
        vm.close();
      }
    },
    addLabelHandler(tag_name) {
      const vm = this;
      vm.userLabels.push({
        tag_name,
        tag_id: null,
        type: 'new',
        tag_key: vm.time + 1
      });
    },
    close() {
      const vm = this;
      vm.$emit('closeModelHandler');
      vm.showModel = false;
    },
    save() {
      const vm = this;
      const store_info = {
        member_uuid: vm.user.member_uuid || vm.user.member_line_uuid,
        tags: vm.userLabels
      };
      // 儲存
      vm.$store.dispatch('sa_reservation/storeTagsHandler', store_info)
        .then(() => {
          vm.$emit('closeModelHandler');
          vm.showModel = false;
          vm.$snotify.success(null, '儲存成功');
        });
    },
  },
  beforeDestroy() {
    this.$EventBus.$off('openTagModel');
  },
  computed: {
    ...mapState({
      tags: (state) => state.sa_reservation.tags,
      memberTags: (state) => state.sa_reservation.memberTags
    }),
    baLabels() {
      const vm = this;
      return _.filter(vm.userLabels, (val) => val.type === 'ba' || val.type === 'new');
    },
    backendLabels() {
      const vm = this;
      return _.filter(vm.userLabels, (val) => val.type === 'backend');
    },
  },
};
</script>

<style lang="scss" scoped>

  .bottom-left {
    width: 35%;
  }

  .bottom-right {
    width: 35%;
    left: initial;
    right: 10%;
  }
</style>
